'use client'

/**
 * Monthly / Annual for the fal-key plans, with what annual saves: on /pricing and the fal-key side of
 * /select-plan. Show it only while `isByokAnnualEnabled()`.
 */
export function ByokPeriodSwitch({
  yearly,
  offer,
  onChange,
}: {
  yearly: boolean
  /** The launch price is on: annual saves up to 40% against it, about 20% against the regular prices. */
  offer: boolean
  onChange: (yearly: boolean) => void
}) {
  return (
    <div className="flex items-center gap-3 text-sm">
      <div role="group" aria-label="Billing period" className="inline-flex rounded-full border border-white/10 p-0.5">
        {[false, true].map(y => (
          <button
            key={String(y)}
            type="button"
            aria-pressed={yearly === y}
            onClick={() => onChange(y)}
            className={`h-8 rounded-full px-3.5 font-medium transition-colors duration-150 ${
              yearly === y ? 'bg-white/15 text-white' : 'text-white/50 hover:text-white'
            }`}
          >
            {y ? 'Annual' : 'Monthly'}
          </button>
        ))}
      </div>
      <span className="text-white/45">{offer ? 'Save up to 40% with annual' : 'Save about 20% with annual'}</span>
    </div>
  )
}
